<div class="extra-info" *ngIf="hasDocuments() && hasTextButton()">
  <h5>{{ 'FIELDS.EXTRA_INFO' | translate }}</h5>
  <ng-container>
    <ion-button
      *ngIf="documents.file1 && documents.file1DownloadButtonText !== ''"
      target="_blank"
      fill="outline"
      [href]="documents.file1">
      {{ documents.file1DownloadButtonText }}
    </ion-button>
    <ion-button
      *ngIf="documents.file2 && documents.file2DownloadButtonText !== ''"
      target="_blank"
      fill="outline"
      [href]="documents.file2">
      {{ documents.file2DownloadButtonText }}
    </ion-button>
    <ion-button
      *ngIf="documents.file3 && documents.file3DownloadButtonText !== ''"
      target="_blank"
      fill="outline"
      [href]="documents.file3">
      {{ documents.file3DownloadButtonText }}
    </ion-button>
    <ion-button
      *ngIf="documents.file4 && documents.file4DownloadButtonText !== ''"
      target="_blank"
      fill="outline"
      [href]="documents.file4">
      {{ documents.file4DownloadButtonText }}
    </ion-button>
  </ng-container>
</div>
